module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalk.5bb4f719.jpg";